import { Chip } from "@bsm/component"
import { TUserStudentScholarity } from "@bsm/graphql"

export const DateScholarity = (props: Props) => {
    
    const formatScholarityDate = () => {
        const [startYear, endYear] = props?.schoolYear.split("-").map(Number);

        // const startMonth = moment(props?.monthBegin, "M").locale("fr").format("MMMM");
        // const endMonth = moment(props?.monthEnd, "M").locale("fr").format("MMMM");

        return `${startYear} - ${endYear}`;
    };

    return (
        <div className="flex gap-2">
            <Chip
                label={formatScholarityDate()}
            />
        </div>
    ) 
}

type Props = Partial<TUserStudentScholarity>
